<template>
  <div>
    <v-row><h1 class="titulo-pagina">Listagem de Inscrições</h1></v-row>

    <v-row>
      <v-col>
        <v-text-field
          v-model="search"
          filled
          append-icon="mdi-magnify"
          label="Pesquise..."
          clearable
          persistent-hint
          hint="Aqui você pode pesquisar por nome do municipio, nome da sala/parceiro, pelo nome do responsável e por status. O filtro ocorre enquanto você digita"
        ></v-text-field>
      </v-col>
      <v-col>
        <combo-estados
          :filter="payload"
          :tipoInscricao="'A'"
          :valor="'nome'"
        ></combo-estados>
      </v-col>
      <v-col>
        <combo-municipio :filter="payload" :uf="payload.uf"></combo-municipio>
      </v-col>
      <v-col>
        <v-autocomplete
          id="temas-select"
          v-model="payload.statusFiltro"
          :items="status"
          placeholder="Selecione um status"
          label="Status"
          filled
          :clearable="true"
          :return-object="true"
          hide-details="auto"
          multiple
        >
          <template slot="no-data"> Nenhum status retornado </template>
        </v-autocomplete>
      </v-col>
      <v-col>
        <v-autocomplete
          id="temas-select"
          v-model="payload.tipoFiltro"
          :items="tipos"
          placeholder="Selecione um tipo"
          label="Tipo"
          filled
          :clearable="true"
          :return-object="true"
          hide-details="auto"
          multiple
        >
          <template slot="no-data"> Nenhum tipo retornado </template>
        </v-autocomplete>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-btn
          color="success"
          outlined
          @click="downloadXls"
          style="margin-right: auto"
        >
          <v-icon title="Excel Inscrição" color="success" class="edit"
            >mdi-file-excel</v-icon
          >
          Inscrição
        </v-btn>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <v-form ref="form">
          <v-data-table
            :headers="headers"
            :items="inscricoes"
            class="a elevation-1"
            calculate-widths
            :search="search"
            :custom-filter="filterItems"
            :items-per-page="20"
            :footer-props="{
              showFirstLastPage: true,
              'items-per-page-options': [20, 50, 100, -1],
              itemsPerPageText: 'Itens por página',
            }"
          >
            <template slot="no-data"> Sem inscrições cadastradas </template>
            <template v-slot:item.tipo="{ item }">
              <span v-if="item.tipo == 0">Sala do Empreendedor</span>
              <span v-else-if="item.tipo == 1">Parceiro</span>
            </template>
            <template v-slot:footer.page-text="items">
              {{ items.pageStart }} - {{ items.pageStop }} de
              {{ items.itemsLength }}
            </template>

            <template v-slot:item.save="{ item, index }">
              <v-icon
                title="PDF Inscrição"
                color="primary"
                class="edit"
                @click="downloadPdf(item)"
                >mdi-file-pdf</v-icon
              >
            </template>
          </v-data-table>
        </v-form>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { inscricaoAPI, municipioAPI } from "@/apis";
import { mapActions, mapGetters } from "vuex";
import ComboMunicipio from "@/modules/municipios/components/ComboMunicipioUf";
import ComboEstados from "@/modules/municipios/components/ComboEstados.vue";
import Swal from "sweetalert2";
import Validar from "./validar.vue";
import moment from "moment";
import { criarLinkRelatorio } from "@/helpers/gerarRelatorio";

export default {
  components: { ComboMunicipio, ComboEstados, Validar },
  mounted() {
    this.getMunicipios();
  },
  computed: {
    ...mapGetters(["loading", "isFullAdmin"]),
  },
  watch: {
    payload: {
      handler(to, from) {
        this.inscricoes = this.allInscricoes;
        if (to.uf) {
          this.inscricoes = this.inscricoes.filter((val) => val.uf === to.uf);
          if (to.municipio) {
            this.inscricoes = this.inscricoes.filter(
              (val) => val.municipio == to.municipio.nome
            );
          }
        }

        if (to.statusFiltro && to.statusFiltro.length > 0) {
          this.inscricoes = this.inscricoes.filter((val) => {
            return to.statusFiltro.some((i) => i == val.status);
          });
        }
        if (to.tipoFiltro && to.tipoFiltro.length > 0) {
          this.inscricoes = this.inscricoes.filter((val) => {
            return to.tipoFiltro.some((i) => i.value == val.tipo);
          });
        }
      },
      deep: true,
    },
  },
  methods: {
    ...mapActions(["setLoading"]),
    filterItems(val, search) {
      console.log("val: ", val);
      console.log("search: ", search);
      var s = search.toString().toLowerCase();

      var result =
        val != null &&
        typeof val !== "boolean" &&
        val.toString().toLowerCase().indexOf(s) > -1;

      return result;
    },
    diminuirValue(item, length) {
      var tamanho = length || 20;
      if (item && item.length > tamanho) {
        return item.substring(0, tamanho) + "...";
      }

      return item;
    },
    mandarEmail(inscricao) {
      this.setLoading(true);
      inscricaoAPI
        .enviarEmailRejeicao(inscricao)
        .then((resp) => {
          this.$notification.success("Email enviado com sucesso");

          this.setLoading(false);
        })
        .catch((resp) => {
          console.log("resp: ", resp);
          this.setLoading(false);
          this.$notification.error("Erro ao mandar email");
        });
    },
    downloadPdf(inscricao) {
      console.log("inscricao: ", inscricao);
      this.setLoading(true);
      inscricaoAPI
        .downloadPdf({ ...inscricao, parceiro: inscricao.tipo == 1 || false })
        .then((resp) => {
          let blob = new Blob([resp.data], {
            type: "application/force-download",
          });
          let link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = `Inscrição - ${inscricao.municipio.toLowerCase()} - ${
            inscricao.uf
          } - ${moment().format("DD_MM_YYYY_HH_mm")}.pdf`;
          link.target = "_blank";
          link.click();
          this.setLoading(false);
        })
        .catch((resp) => {
          console.log("resp: ", resp);
          this.setLoading(false);
          this.$notification.error("Erro ao obter anexo");
        });
    },
    downloadXls() {
      this.setLoading(true);
      inscricaoAPI
        .downloadExcelInscritos()
        .then(({ data }) => {
          criarLinkRelatorio(
            data,
            `Inscrições 2026 - ${moment().format("DD_MM_YYYY_HH_mm")}.xlsx`
          );
          this.setLoading(false);
        })
        .catch((resp) => {
          console.log("resp: ", resp);
          this.setLoading(false);
          this.$notification.error("Erro ao obter anexo");
        });
    },
    aprovar(item) {
      Swal.fire({
        title: "Aprovar Inscrição",
        html: `Confirma que deseja aprovar a inscrição do município ${
          item.nome
        } ${item.tipo == "Parceiro" ? "do parceiro" : "da sala"} ${
          item.resposta8 ? item.resposta8 : "(sem nome cadastrado)"
        } / ${item.uf}? 

     
         `,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        cancelButtonText: "Não",
        confirmButtonText: "Sim",
      }).then((result) => {
        if (result.isConfirmed) {
          this.setLoading(true);
          inscricaoAPI
            .aprovarInscricao(item)
            .then(({ data }) => {
              this.setLoading(false);
              this.getInscricao();
            })
            .catch((err) => {
              console.log("Error aprovar in inscricao/listar: ", err);
              this.$notification.error("Erro ao aprovar uma inscrição");
              this.setLoading(false);
            });
        } else {
          this.setLoading(false);
        }
      });
    },
    reenviarConfirmacao(item) {
      this.setLoading(true);
      inscricaoAPI
        .enviarEmailConfirmando(item.registroId)
        .then(({ data }) => {
          this.setLoading(false);
          //this.$router.push("/inscricao");
        })
        .catch((err) => {
          console.log("Error reenviarConfirmacao in inscricao/listar: ", err);
          this.$notification.error("Erro ao enviar email de confirmação");
          this.setLoading(false);
        });
    },
    reenviarValidacao(item) {
      this.setLoading(true);
      inscricaoAPI
        .enviarEmailValidacao(item.registroId)
        .then(({ data }) => {
          this.setLoading(false);
          //this.$router.push("/inscricao");
        })
        .catch((err) => {
          console.log("Error reenviarValidacao in inscricao/listar: ", err);
          this.$notification.error("Erro ao enviar email de validação");
          this.setLoading(false);
        });
    },
    cancel(item) {
      var allInscricoesItem = this.allInscricoes.filter(
        (val) => val.registroId === item.registroId
      )[0];

      item.nome = allInscricoesItem.nome;
      item.email = allInscricoesItem.email;
      item.nomeSala = allInscricoesItem.nomeSala;

      item.edit = false;

      this.$forceUpdate();
    },
    async save(item) {
      var isValid = await this.check();
      if (!isValid) {
        this.$notification.error(
          "Atenção - todos os campos são obrigatórios! Verifique o preenchimento!",
          { timer: 10 }
        );
        return;
      }
      this.setLoading(true);
      inscricaoAPI
        .update(item)
        .then(({ data }) => {
          item.edit = false;
          this.setLoading(false);
          //this.$router.push("/inscricao");
        })
        .catch((err) => {
          console.log("Error save in inscricao/listar: ", err);
          this.$notification.error("Erro ao salvar uma inscrição");
          this.setLoading(false);
        });
    },
    async check() {
      const isValid = await this.$refs.form.validate();
      return isValid;
    },
    getInscricao() {
      this.setLoading(true);

      inscricaoAPI
        .list()
        .then(({ data }) => {
          this.inscricoes = data.data.map((item) => ({
            ...item,
            edit: false,
          }));
          this.allInscricoes = data.data.map((item) => ({
            ...item,
            edit: false,
          }));
          this.setLoading(false);
          //this.$router.push("/inscricao");
        })
        .catch((err) => {
          console.log("Error getInscricao in inscricao listar: ", err);
          this.$notification.error("Erro ao buscar inscrições");
          this.setLoading(false);
        });
    },
    getMunicipios() {
      this.setLoading(true);

      municipioAPI
        .list()
        .then(({ data }) => {
          this.municipios = data.data;
          this.getInscricao();
          //this.$router.push("/inscricao");
        })
        .catch((err) => {
          console.log("Error getMunicipio in inscricao listar: ", err);
          this.$notification.error("Erro ao buscar municipios");
          this.setLoading(false);
        });
    },
  },
  data() {
    return {
      status: ["Em preenchimento", "Concluída"],
      headers: [
        { text: "PDF", value: "save", width: "8%" },
        { text: "UF", value: "uf", width: "8%" },
        { text: "Tipo", value: "tipo", width: "10%" },
        { text: "Município - Nome Sala", value: "municipio" },
        { text: "Responsável", value: "nomeResponsavel", width: "20%" },
        { text: "Status", value: "status" },
      ],
      tipos: [
        { text: "Sala do Empreendedor", value: 0 },
        { text: "Parceiro", value: 1 },
      ],
      rules: [(v) => !!v || "Campo Obrigatório"],
      rulesLength: [
        (v) => {
          if (!v) return "Campo Obrigatório";
          else if (v.length < 14) return "Telefone inválido";
          return true;
        },
      ],
      emailREgex:
        /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/,
      emailRules: [
        (v) =>
          !v
            ? "Campo Obrigatório"
            : !this.emailREgex.test(v)
            ? "E-mail inválido"
            : true,
      ],
      search: "",
      municipios: [],
      inscricoes: [],
      allInscricoes: [],
      recuperado: false,
      payload: {},
      logo: this.$store.state.logo,
    };
  },
};
</script>
<style>
/* .a table {
  table-layout: fixed;
} */
</style>
<style lang="scss" scoped>
@import "@/variables.scss";

.edit {
  cursor: pointer;
  padding: 5px;
}

.edit:hover {
  color: #2a4fda !important;
  caret-color: #2a4fda !important;
  box-shadow: 0 2px 4px -1px rgba(0, 0, 0, 0.2), 0 4px 5px 0 rgba(0, 0, 0, 0.14),
    0 1px 10px 0 rgba(0, 0, 0, 0.12);
}

.btna {
  font-size: 8px;
  margin-left: 0 !important;
  text-transform: capitalize;
}

.width {
  //max-width: 1000px;
  margin: 0 auto;
}

.title-form {
  color: $cor-selo-texto;
  font-weight: 500;
  margin: 1rem 0;
}
</style>
